import * as yup from 'yup';

export const getAddLocationSchema = () => {
    return yup.object().shape({
        creationMode: yup.string().oneOf(['google', 'manual']),
        placeId: yup.string().when('creationMode', {
            is: 'google',
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        internalName: yup.string().when('creationMode', {
            is: 'manual',
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        locationName: yup.string().when('creationMode', {
            is: 'manual',
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        type: yup.number().when('creationMode', {
            is: 'manual',
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        phoneNumber: yup.string().when('creationMode', {
            is: 'manual',
            then: schema => schema.validatePhone('validation.wrongPhoneFormat').required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        country: yup.string().when('creationMode', {
            is: 'manual',
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        primaryCategory: yup.array().when('creationMode', {
            is: 'manual',
            then: schema => schema.min(1, 'validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        hasBusinessAddress: yup.boolean(),
        addressLine1: yup.string().when(['creationMode', 'hasBusinessAddress'], {
            is: (creationMode, hasBusinessAddress) => creationMode === 'manual' && hasBusinessAddress,
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        city: yup.string().when(['creationMode', 'hasBusinessAddress'], {
            is: (creationMode, hasBusinessAddress) => creationMode === 'manual' && hasBusinessAddress,
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
        postalCode: yup.string().when(['creationMode', 'hasBusinessAddress'], {
            is: (creationMode, hasBusinessAddress) => creationMode === 'manual' && hasBusinessAddress,
            then: schema => schema.required('validation.required'),
            otherwise: schema => schema.nullable(),
        }),
    });
};
